<template>
	<a class="news-link" :href="path">
		<div class="row-2 f-cb">
			<h2 class="title f-toe1">{{item.listTitle|| item.title}}</h2>
			<span class="comment-count" v-if="item.comments!='0'&& item.comments">{{item.comments}}</span>
		</div>
		<div class="row-1 f-cb">
			<div class="col-1" :style="{height: imgH}">
				<div class="bg-d">
					<div class="bg-c" :style="{backgroundImage:'url(' + webp(item.images[0]) + ')'}"></div>
				</div>
			</div>
			<div class="col-2" :style="{height: imgH}">
				<div class="bg-d">
					<div class="bg-c" :style="{backgroundImage:'url(' + webp(item.images[1]) + ')'}"></div>
				</div>
			</div>
		</div>
		
	</a>
</template>

<script>
import { mapGetters } from 'vuex'
import imgMixin from 'mixins/image'
import newsItemMixin from 'mixins/news-item'
export default {
	mixins: [imgMixin, newsItemMixin],
	props: ['item'],
	computed: {
		...mapGetters({
			appW: 'app:width'
		}),
		imgH() {
			const imgW = (this.appW - 30)/2;
			return imgW * 3/4 + 'px';
		},
		showComment() {
			const count = this.item.comments + '';
			if(!Jt.string.isEmpty(count) && count !== '0') {
				return true;
			}
			return false;
		}
	}
}

</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	@import '~src/styles/page-topic.styl';
	@import '~src/styles/news-stream.styl';
</style>


// WEBPACK FOOTER //
// news-img.vue?3d83b0cd